<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="mx-auto container-xl mb-5">
      <!-- Status indicator -->
      <!-- Survey information form, status and action buttons -->
      <div class="">
        <div class="title-area">
          <h1 class="page-title h2 mb-5">
            My surveys
          </h1>
        </div>
      </div>
      
      <div class="survey-table allsurveys-table">
        <BaseModal v-model="wipeconfirm" title="Delete survey permanently?">
            <p v-if="wipesurvey">
              WARNING! This operation will physically delete ALL information for this survey,
              including survey participants, answers to survey questions, and all reports.
            </p>
            <div v-if="wipesurveys.length > 0">
              WARNING! This operation will physically delete ALL information for the selected surveys,
              including survey participants, answers to survey questions, and all reports.
              <br />
              <br />
              This can take a long time depending on the amount of surveys selected. Please do not close the browser
              window.
            <ul class="mt-3">
              <li v-for="survey in wipesurveys" :key="survey.id" class="mb-1">{{ survey.name }} ({{ survey.id }})</li>
            </ul>
            </div>
            <p><strong>THIS OPERATION CANNOT BE REVERSED.</strong></p>
          <template #modal-footer>
            <button class="btn btn-danger w-100 mt-3" @click="survey_deletefromdatabase(wipesurvey)">
              Delete
            </button>
            <button class="btn btn-secondary w-100 mt-2" @click="wipeconfirm = false; wipesurvey = false;">
              Cancel
            </button>
          </template>
        </BaseModal>
        
        <BaseModal v-model="wipeprogress" title="Permanently deleting survey(s)">
          <template #body>
            <div class="row">
              <div class="col-12 text-center">
                <h5>Deleting survey(s)</h5>
              </div>
            </div>
            <div class="col-12 text-center">
              <div class="spinner-border text-danger" style="width: 4rem; height: 4rem;" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </template>
        </BaseModal>
        
        <BaseModal v-model="deleteconfirm_show" title="Confirm">
          <template #body>
            D ya?
          </template>
        </BaseModal>

        <div class="table-filter-area">
          <div class="row">
            <div class="col-md-8">
              <div class="mb-3">
                <input type="text" class="form-control" v-model="search" @input="handleSearch" placeholder="Search" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <select class="form-select" v-model="group_id" :class="`${anon ? 'g-anon' : ''}`" @change="set_group()">
                  <option v-for="option in groups" :key="option.value" :value="option.value" :disabled="option.disabled">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="table-button-area mb-3">
            <div class="d-flex justify-content-between">
              <div>
                <button class="btn btn-small"
                  :class="{ 'btn-primary': survey_status_id === 3, 'btn-secondary': survey_status_id !== 3 }"
                  @click="filter_table(3)">
                  Ongoing ({{ surveycount_3 }})
                </button>
                <button class="btn btn-small"
                  :class="{ 'btn-primary': survey_status_id === 1, 'btn-secondary': survey_status_id !== 1 }"
                  @click="filter_table(1)">
                  Drafts ({{ surveycount_1 }})
                </button>
                <button class="btn btn-small"
                  :class="{ 'btn-primary': survey_status_id === 2, 'btn-secondary': survey_status_id !== 2 }"
                  @click="filter_table(2)">
                  Scheduled ({{ surveycount_2 }})
                </button>
                <button class="btn btn-small"
                  :class="{ 'btn-primary': survey_status_id === 4, 'btn-secondary': survey_status_id !== 4 }"
                  @click="filter_table(4)">
                  Completed ({{ surveycount_4 }})
                </button>
                <button class="btn btn-small"
                  :class="{ 'btn-primary': survey_status_id === 5, 'btn-secondary': survey_status_id !== 5 }"
                  @click="filter_table(5)">
                  Trash ({{ surveycount_5 }})
                </button>
              </div>
              <div class="text-right">
                <router-link to="/create">
                  <button class="btn btn-small btn-primary"><i class="fa fa-regular fa-plus me-2"></i>New survey</button>
                </router-link>
                <button class="btn btn-small btn-secondary" @click="clearFilters">Clear filter</button>
                <button class="btn btn-small btn-secondary" @click.prevent="wipeconfirm = true"
                  :disabled="wipesurveys.length === 0">
                  Delete
                </button>
              </div>
            </div>
          </div>

        </div>

        <div v-if="loading" class="text-center text-success my-2">
          <div class="spinner-border align-middle me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <strong>Loading...</strong>
        </div>

        <BaseTable
          v-else
          :items="surveys"
          :fields="fields"
          class="table surveytable"
          hover
          responsive
        >
          <template v-slot:head(select)>
            <input type="checkbox" class="form-check-input" :checked="allSelected" @change="selectall($event.target.checked)" />
          </template>

          <template v-slot:cell(select)="{ data }">
            <div>
              <input type="checkbox" class="form-check-input" v-model="data.item.selected" @change="countselected" />
            </div>
          </template>

          <template v-slot:cell(survey_name)="{ data }">
            <span :class="`${anon ? 'g-anon' : ''}`" @click="openSurveyPage(data.item, data.index, $event)">
              <i class="fa-regular fa-square-poll-vertical"></i>&nbsp;&nbsp;{{ data.item.survey_name }} ({{ data.item.id }})
            </span>
          </template>

          <template v-slot:cell(group_id)="{ data }">
            <span :class="`${anon ? 'g-anon' : ''}`">
              {{ data.item.group_id }}
            </span>
          </template>

          <template v-slot:cell(survey_type_id)="{ data }">
            {{ data.value }}
          </template>

          <template v-slot:cell(survey_status)="{ data }">
            <span :class="getClassColor('status', data.item)" class="pill">{{ surveyTypeName(data.item.survey_status_id) }}
            </span>
          </template>

          <template v-slot:cell(survey_start_date)="{ data }">
            {{ data.item.survey_start_date > '1970-01-02' ? format_date(data.item.survey_start_date) : 'Not set' }}
          </template>

          <template v-slot:cell(survey_end_date)="{ data }">
            {{ data.item.survey_end_date > '1970-01-02' ? format_date(data.item.survey_end_date) : 'Not set'}}
          </template>

          <template v-slot:cell(survey_replied)="{ data }">
            <span :class="getClassColor('member', data.item)" class="pill">{{ data.item.completecount }}/{{
              data.item.membercount }}</span>
          </template>

          <template v-slot:cell(actions)="{ data }">
            <BaseDropdown right variant="link" class="actions-dropdown">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <a class="dropdown-item" @click.prevent="openSurveyPageId(data.item)">Edit</a>
              <a v-if="survey_status_id !== 5" class="dropdown-item"
                @click.prevent="survey_delete(data.item.id, data.item.survey_deleted, data.item.survey_status_id, data.item.completecount)">Trash</a>
              <a v-if="survey_status_id === 5" class="dropdown-item"
                @click.prevent="survey_delete(data.item.id, data.item.survey_deleted, data.item.survey_status_id, data.item.completecount)">Restore</a>
              <a class="dropdown-item" @click.prevent="wipeconfirm = true; wipesurvey = data.item.id">
                Delete
              </a>
            </BaseDropdown>
          </template>

        </BaseTable>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import Navbar from '../Navbar.vue'
import Breadcrumb from '../Breadcrumb.vue'

const props = defineProps({
  surveytype: {
    type: String,
    default: ''
  }
})

const store = useStore()
const router = useRouter()

// Reactive state
const wipeconfirm = ref(false)
const wipeprogress = ref(false)
const wipesurvey = ref(0)
const wipesurveys = ref([])
const loading = ref(true)
const surveysselected = ref(0)
const surveys_total = ref(0)
const surveys_retrieved = ref(10)
const survey_status_id = ref(3)
const allSelected = ref(false)
const search = ref('')
const group_id = ref(null)
const surveycount_1 = ref(0)
const surveycount_2 = ref(0)
const surveycount_3 = ref(0)
const surveycount_4 = ref(0)
const surveycount_5 = ref(0)
const deleteconfirm = ref(1)
const deleteconfirm_show = ref(false)
const surveys = ref([])

const fields = [
  { key: 'select', label: 'S', sortable: false, tdClass: 'select-td', thClass: 'select-th' },
  { key: 'survey_name', sortable: true, label: 'Survey name', thStyle: 'width: 22%', tdStyle: 'width: 22%' },
  { key: 'group_id', sortable: true, label: 'Group', thStyle: 'width: 15%', tdStyle: 'width: 15%' },
  { key: 'survey_type_id', sortable: true, label: 'Type', thStyle: 'width: 70px', tdStyle: 'width: 70px' },
  { key: 'survey_status', sortable: true, label: 'Status' },
  { key: 'survey_start_date', sortable: true, label: 'Start date', thStyle: 'width: 125px', tdStyle: 'width: 125px' },
  { key: 'survey_end_date', sortable: true, label: 'End date', thStyle: 'width: 125px', tdStyle: 'width: 125px' },
  { key: 'survey_replied', sortable: false, label: 'Replied', thStyle: 'width: 100px', tdStyle: 'width: 100px' },
  { key: 'actions', label: 'Actions', sortable: false, class: 'ellipsis-button' }
]

// Computed
const consultant_id = computed(() => store.state.user_id)
const anon = computed(() => store.state.anon)
const mygdqpage_reload = computed(() => store.state.mygdqpage_reload)
const setadmin_done = computed(() => store.state.questionnaire_admin_done)
const groups = computed(() => {
  const items = (store.state.groups || []).filter(f => Number(f.group_deleted) === 0)
  const result = [{ value: null, text: 'Select group', disabled: true }]
  for (const item of items) {
    result.push({ value: item.id, text: item.group_name })
  }
  return result
})

// Watchers
watch(mygdqpage_reload, () => {
  loading.value = true
  surveys_get()
})

watch(setadmin_done, () => {
  loading.value = true
  surveys_get()
})

// Lifecycle
onMounted(() => {
  loading.value = true
  groups_get()
  surveys_get()
  store.dispatch('questionnaire_setadmin', { admin: false })
  store.dispatch('questionnaire_setadmin_code', { code: '' })
  store.dispatch('questionnaire_setadmin_done', { done: false })
  surveycounts_get()
})

// Methods
const clearFilters = () => {
  search.value = ''
  survey_status_id.value = 3
  group_id.value = null
  allSelected.value = false
  surveys_get()
}

const set_group = () => {
  surveys_get()
}

let searchTimeout = null
const handleSearch = () => {
  clearTimeout(searchTimeout)
  searchTimeout = setTimeout(() => {
    surveys_get()
  }, 1000)
}

const filter_table = (status_id) => {
  survey_status_id.value = status_id
  allSelected.value = false
  surveys_get()
}

const surveyTypeName = (id) => {
  switch (Number(id)) {
    case 1: return 'Draft'
    case 2: return 'Scheduled'
    case 3: return 'Ongoing'
    case 4: return 'Completed'
    default: return 'Default'
  }
}

const survey_deletefromdatabase = async () => {
  wipeconfirm.value = false
  wipeprogress.value = true
  if (wipesurvey.value) {
    await store.dispatch('groupsurvey_wipe', { id: wipesurvey.value })
    wipesurvey.value = 0
  } else if (wipesurveys.value.length > 0) {
    for (let i = 0; i < wipesurveys.value.length; i++) {
      await store.dispatch('groupsurvey_wipe', { id: surveys.value[i].id })
    }
    wipesurveys.value = []
  }
  loading.value = true
  surveys_get()
  surveycounts_get()
  wipeprogress.value = false
}

const surveycounts_get = async () => {
  const filter = { survey_deleted: { operator: '=', value: 0, realfield: 1 } }
  surveycount_1.value = await store.dispatch('surveys_fetch', {
    filter: { ...filter, survey_status_id: { operator: '=', value: 1, realfield: 1 } }, countonly: 1
  }).then(r => r.data.total)
  surveycount_2.value = await store.dispatch('surveys_fetch', {
    filter: { ...filter, survey_status_id: { operator: '=', value: 2, realfield: 1 } }, countonly: 1
  }).then(r => r.data.total)
  surveycount_3.value = await store.dispatch('surveys_fetch', {
    filter: { ...filter, survey_status_id: { operator: '=', value: 3, realfield: 1 } }, countonly: 1
  }).then(r => r.data.total)
  surveycount_4.value = await store.dispatch('surveys_fetch', {
    filter: { ...filter, survey_status_id: { operator: '=', value: 4, realfield: 1 } }, countonly: 1
  }).then(r => r.data.total)
  surveycount_5.value = await store.dispatch('surveys_fetch', {
    filter: { survey_deleted: { operator: '=', value: 1, realfield: 1 } }, countonly: 1
  }).then(r => r.data.total)
}

const survey_delete = (id, survey_deleted) => {
  deleteconfirm.value = 1
  if (survey_deleted === 0) {
    if (!confirm('Are you sure you want to move this survey to trash?')) {
      deleteconfirm.value = 0
    }
  }
  if (deleteconfirm.value === 1) {
    store.dispatch('groupsurvey_update', { survey: { id, survey_deleted: 1 - survey_deleted } }).then(() => {
      surveys_get()
      surveycounts_get()
    })
  }
}

const selectall = (event) => {
  allSelected.value = event
  surveys.value.forEach(survey => { survey.selected = event })
  countselected()
}

const countselected = () => {
  const selectedsurveys = surveys.value
    .filter(s => s.selected === true)
    .map(s => ({ id: s.id, name: s.survey_name }))
  surveysselected.value = selectedsurveys.length
  wipesurveys.value = selectedsurveys
  store.dispatch('groupsurveys_setselected', { surveys: selectedsurveys })
}

const groups_get = () => {
  store.dispatch('groups_fetch')
}

const surveys_get = () => {
  loading.value = true

  let filter = {
    user_id: { operator: '=', value: consultant_id.value, realfield: 1 },
    survey_deleted: { operator: '=', value: 0, realfield: 1 }
  }

  if (survey_status_id.value) {
    filter.survey_status_id = { operator: '=', value: survey_status_id.value, realfield: 1 }
  }

  if (survey_status_id.value === 5) {
    filter = {
      user_id: { operator: '=', value: consultant_id.value, realfield: 1 },
      survey_deleted: { operator: '=', value: 1, realfield: 1 }
    }
  }

  if (group_id.value) {
    filter.group_id = { operator: '=', value: group_id.value, realfield: 1 }
  }

  if (search.value) {
    filter.survey_name = { operator: 'LIKE', value: `*${search.value}*`, realfield: 1 }
  }

  store.dispatch('surveys_fetch', { filter }).then((resp) => {
    surveys.value = resp.data.result.map(survey => ({ ...survey, selected: false }))
    surveys_retrieved.value = resp.data.result.length
    surveys_total.value = resp.data.total
    loading.value = false
  })
}

const openSurveyPage = (item, index, event) => {
  const element = event.target
  const navigate = () => {
    store.dispatch('groupsurvey_setcurrent', { survey_id: item.id }).then(() => {
      if (Number(item.survey_status_id) === 1) {
        store.dispatch('groupsurveymembers_addnewgroupmembers', { survey_id: item.id })
        router.push('/create/group/survey/details')
      } else {
        router.push('/group/survey')
      }
    })
  }

  const includedTags = ['span', 'i']
  if (includedTags.includes(element.tagName.toLowerCase())) {
    navigate()
    return
  }

  const isFirstElement = !element.previousSibling
  const isLastElement = !element.nextSibling
  if (!isLastElement && !isFirstElement) {
    navigate()
  }
}

const openSurveyPageId = (item) => {
  store.dispatch('groupsurvey_setcurrent', { survey_id: item.id }).then(() => {
    if (Number(item.survey_status_id) === 1) {
      router.push('/create/group/survey/details')
    } else {
      router.push('/group/survey')
    }
  })
}

const getClassColor = (type, survey) => {
  if (type === 'member') {
    const { completecount, membercount } = survey
    if (completecount === 0) return 'bg-danger'
    if (completecount > 0 && completecount < membercount) return 'bg-warning'
    if (completecount === membercount) return 'bg-secondary'
  } else if (type === 'status') {
    switch (Number(survey.survey_status_id)) {
      case 1: return 'bg-danger'
      case 2: return 'bg-secondary'
      case 3: return 'bg-warning'
      case 4: return 'bg-primary'
    }
  }
  return ''
}

const format_date = (date) => {
  const d = new Date(date)
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()
  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  return [year, month, day].join('-')
}
</script>
<style scoped>
td {
  cursor: pointer !important;
}
</style>
